import { styled } from '@mui/material/styles';
//eslint-disable-next-line no-restricted-imports
import ErrorPageIcon from './error-page-icon.svg';

export default styled(ErrorPageIcon)(({ theme }) => ({
  width: 484,
  maxWidth: '100%',
  height: 251,
  '& .fill-outline': {
    fill: theme.palette.neutral.outline,
  },
  '& .stroke-outline': {
    stroke: theme.palette.neutral.outline,
  },
  '& .fill-secondary': {
    fill: theme.palette.secondary.main,
  },
  '& .stroke-secondary': {
    stroke: theme.palette.secondary.main,
  },
  '& .fill-error': {
    fill: theme.palette.error.main,
  },
  '& .stroke-error': {
    stroke: theme.palette.error.main,
  },
  '& .fill-warning': {
    fill: theme.palette.warning.main,
  },
  '& .stroke-warning': {
    stroke: theme.palette.warning.main,
  },
  '& .fill-white': {
    fill: theme.palette.neutral.containerHighest,
  },
}));

